import { memo, useCallback } from 'react'

import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Header } from '@shared/components/Header'
import { Content } from '@shared/layouts'
import { useMediaChannelEntryUpdateMutation } from 'hooks/mutations/publishing'
import { mediaChannelEntryIndexRoute } from 'pages/NWPlatform/MediaChannels/MediaChannel/MediaChannelEntry/Routing'
import { mediaChannelQueryKeys } from 'services/queryKeys'

const StructureRaw = () => {
  const { t } = useTranslation(['common', 'pages', 'entity'])
  const { enqueueSnackbar } = useSnackbar()

  const { mediaChannelId, mediaChannelEntryId } = mediaChannelEntryIndexRoute.useParams()

  const mediaChannelEntryQuery = useQuery(
    mediaChannelQueryKeys.entryDetail({ channelId: mediaChannelId, entryId: mediaChannelEntryId }),
  )
  const { data: channelEntry } = mediaChannelEntryQuery

  const { mutate: updateChannelEntry, ...channelEntryUpdateMutation } = useMediaChannelEntryUpdateMutation()

  const handleUpdateChannelEntryName = useCallback(
    (title: string, closeCallback: () => void) => {
      if (channelEntry) {
        updateChannelEntry(
          {
            channelId: mediaChannelId,
            entryId: mediaChannelEntryId,
            mediaChannelScheduleEntryEdit: {
              name: title,
            },
          },
          {
            onError: () => enqueueSnackbar(t('pages:MediaChannel.updateError')),
            onSettled: closeCallback,
          },
        )
      }
    },
    [t, channelEntry, updateChannelEntry, mediaChannelId, mediaChannelEntryId, enqueueSnackbar],
  )

  return (
    <Content
      HeaderSlot={
        <Header
          title={mediaChannelEntryQuery.data?.name ?? ''}
          isLoading={mediaChannelEntryQuery.isLoading}
          isSaving={channelEntryUpdateMutation.isPending}
          onSave={handleUpdateChannelEntryName}
        />
      }
    />
  )
}

export const Structure = memo(StructureRaw)
